<template>
  <label class="custom-checkbox d-flex justify-content-center align-items-center" :for="id">
      <input
          type="checkbox"
          class="d-none"
          :id="id"
          :name="name"
          :checked="checked"
          @input="$emit('update:checked', $event.target.checked)"
      >
      <span><CheckmarkIcon /></span>
  </label>
</template>

<script>

import CheckmarkIcon from "@/assets/icons/checkmark-icon";
export default {
  components: {CheckmarkIcon},
  props: {
    id: String,
    name: String,
    checked: {
      type: Boolean,
    },
  }
}
</script>
